
import Utils from '@utils/utils';
import { useImperativeHandle, forwardRef, useContext, useState, useRef, useMemo, useEffect } from "react"
import { AppContext } from "@utils/AppContext"
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss'
import { Checkbox } from 'antd';
import API from '@api/api'
import eventBus from '@utils/eventBus';


const WaterDownModal = forwardRef((props, ref) => {
    const {
        globalUser,
    } = useContext(AppContext)

    const [waterOpen, setWaterOpen] = useState(false)
    const [callback, setCallback] = useState(null);
    const [checked, setChecked] = useState(false)



    useImperativeHandle(ref, () => ({
        handleClick
    }))
 
    const handleClick = (callback) => {
        setCallback(() => callback);
        setOpen(true)
    }

    const onWaterOk = () => {
        callback()
        if (checked) {
            API.agreeDownloadNoLogov2().then((res) => {
                if (res.code == 0) {
                    eventBus.emit('updateUserInfo')
                    eventBus.emit('getUserOrgInfo')
                }
            })
        }
        setWaterOpen(false)
    }

    const onWaterCancel = () => {
        API.logout({}).finally(() => {
            navigate('/')
            localStorage.removeItem('token')
            Utils.clearAllTaskCache()
            setWaterOpen(false)
        })
    }


    return (
        <>
            <PSAIModal
                title={'【服务协议】更新声明'}
                maxWidth={520}
                okText={'同意并继续'}
                cancelText={'不同意'}
                open={waterOpen}
                maskClosable={false}
                onCancel={onWaterCancel}
                onOk={onWaterOk}
                cancelButtonProps={{
                    style: {
                        backgroundColor: '#fff',
                        borderColor: '#D6D6D6',
                        color: '#DDDDDD'
                    }
                }}
            >
                <div className={styles.waterDownModal}>
                    欢迎使用PSAI，PSAI已根据【人工智能生成合成内容标识办法】更新<span>《<a target='_blank' href='/服务协议.htm'>服务协议</a>》</span>。
                    请您充分阅读和理解<span>《<a target='_blank' href='/服务协议.htm'>服务协议</a>》</span>和<span>《<a target='_blank' href='/隐私政策.htm'>隐私政策</a>》</span>,
                    以及本提示的全部内容。点击"同意并继续"按钮即代表您已经同意前述协议全部条款。
                </div>
            </PSAIModal>
        </>
    )
})

export default WaterDownModal